var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "top_info"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Circulating Supply")]), _vm.currentSupply ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.convertNum(_vm.inDCM)))]), _c('div', {
    staticClass: "desc",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" " + _vm._s(_vm.inDCM.toLocaleString('us-EN')) + " DCM ")])]) : _c('p', [_vm._v("N/A")]), _c('div', {
    staticClass: "desc"
  }, [_vm.currentSupply ? _c('p', [_c('span', {
    style: {
      fontWeight: 'bolder'
    }
  }, [_vm._v("Total Supply")]), _c('br'), _vm._v(" 720,000,000 DCM ")]) : _c('p', [_vm._v("N/A")])])]), _c('div', {
    staticClass: "chart"
  }, [_c('VueApexChartsComponent', {
    attrs: {
      "type": "radialBar",
      "height": "200",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1)]) : _c('div', {
    staticClass: "top_info"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Circulating Supply")]), _vm.currentSupply ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.convertNum(_vm.inDCM)))])]) : _c('p', [_vm._v("N/A")]), _c('div', {
    staticClass: "desc"
  }, [_vm.currentSupply ? _c('p', [_vm._v(_vm._s(_vm.currentSupply.supply))]) : _c('p', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }